export default __webpack_public_path__ + "assets/images/37248a04f188120760dc546cd5d56719.svg";